'use client';

import { useCallback, useContext } from 'react';

import { NavLink } from '@/components/atoms/NavLink/NavLink';
import { DirectoryTrackingContext } from '@/contexts/DirectoryTracking';
import { DirectoryTrackingEvent } from '@karehero/models';

interface PhoneNumberButtonProps {
  providerName?: string;
  phoneNumber: string;
  regulatoryId?: string;
}
export const PhoneNumberButton = ({
  providerName,
  phoneNumber,
  regulatoryId,
}: PhoneNumberButtonProps) => {
  const { track } = useContext(DirectoryTrackingContext);

  const trackWithProviderInfo = useCallback(
    (evName: string, properties: any) =>
      track?.(evName, {
        providerName,
        regulatoryId,
        ...properties,
      }),
    [providerName, regulatoryId, track],
  );

  return (
    <NavLink
      size='lg'
      leftIcon={'phone'}
      href={`tel:${phoneNumber.replace(/\s/g, '')}`}
      label={phoneNumber}
      isButton
      onClick={() =>
        trackWithProviderInfo?.(
          DirectoryTrackingEvent.DirectoryPhoneNumberClicked,
          {
            phoneNumber,
          },
        )
      }
    />
  );
};
